export const GET_INTO_GROOV = "Want to get into your Groov?";
export const APP_BLURB =
  "The Groov app is developed with clinical experts using the latest research, and Groov’s own mental wellbeing framework. Learn how to take action and make small, sustainable changes to improve you wellbeing.";
export const APP_STORE =
  "Go to the App store to download the Groov app and link it to your workplace.";
export const APP_STORE_LINK =
  "https://apps.apple.com/nz/app/mentemia/id1462692772";
export const PLAY_STORE_LINK =
  "https://play.google.com/store/apps/details?id=com.mentemia.companionapp&hl=en";
